
export default "https://village-co-callback.s3.amazonaws.com/images/savo-beta-logo.png"